module.exports = __webpack_public_path__ + "static/media/vatten.fd816849.mp3";